










import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import { PageSizeSelectOption } from "@/shared/types";
import { usePageSizeStore } from "@/shared/store/pageSize";

@Component
export default class PageSizeSelectList extends Vue {
  pageSizeStore = usePageSizeStore();
  @Prop()
  totalRecords: number;

  get selectedPageSize () {
    return this.pageSizeStore.pageSize;
  }

  set selectedPageSize (pageSize) {
    this.pageSizeStore.setPageSize(pageSize);
  }

  updatePageSize (selectedPageSize: number): void {
    this.$emit("switchPageSize", selectedPageSize);
  }

  get selectOptions (): PageSizeSelectOption[] {
    return this.pageSizeStore.pageSizeSelectOptions(this.totalRecords);
  }
}
